import React, { useEffect } from "react"
import { useState, useCallback } from "react"
import Map from "react-map-gl"

import DrawControl from "./drawControl"

import { initialViewState, MAPBOX_TOKEN, MAP_STYLE } from "../../../constants"

export default function AddFarmArea({ farmAreaGeoJSON, setFeatures }) {
  const [draw, setDraw] = useState(null)
  const [initialSet, setInitialSet] = useState(false)
  useEffect(() => {
    if (draw && !initialSet) {
      draw.set(farmAreaGeoJSON)
      setInitialSet(true)
    }
  }, [draw, farmAreaGeoJSON, initialSet])

  const initialAreas = {}
  for (const a of farmAreaGeoJSON.features) {
    initialAreas[a.id] = a
  }

  const onUpdate = useCallback(
    (e) => {
      setFeatures((currFeatures) => {
        const newFeatures = { ...currFeatures }
        for (const f of e.features) {
          newFeatures[f.id] = f
        }
        return newFeatures
      })
    },
    [setFeatures]
  )

  const onDelete = useCallback(
    (e) => {
      setFeatures((currFeatures) => {
        const newFeatures = { ...currFeatures }
        for (const f of e.features) {
          delete newFeatures[f.id]
        }
        return newFeatures
      })
    },
    [setFeatures]
  )
  return (
    <>
      <Map
        initialViewState={{ ...initialViewState, zoom: 10 }}
        mapStyle={MAP_STYLE}
        mapboxAccessToken={MAPBOX_TOKEN}
        style={{ width: "500px", height: "calc(100vh - 400px)" }}
      >
        <DrawControl
          key={initialViewState?.longitude + '-' + initialViewState?.latitude + '-' + initialViewState?.zoom}
          position="top-left"
          setDraw={setDraw}
          farmAreas={farmAreaGeoJSON}
          displayControlsDefault={false}
          controls={{
            polygon: true,
            trash: true,
          }}
          defaultMode="draw_polygon"
          onCreate={onUpdate}
          onUpdate={onUpdate}
          onDelete={onDelete}
        />
      </Map>
    </>
  )
}
